import ParamBanque from "@/components/parametres/parametre/param-banque";
import AssuranceSociete from '@/components/parametres/parametre/assurance-societes'
import CustomExclusions from '@/components/parametres/parametre/custom_exclusions'

export default {
    name: 'parametre',
    components: {
        ParamBanque, AssuranceSociete, CustomExclusions
    },
    props: [],
    data() {
        return {
            config_to_show: 'banque'
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        changeTab(tab_to_show) {
            this.config_to_show = tab_to_show
        },
    }
}